<template>
	<div
		:class="['mobile-page-select', { 'sticky': false, 'scrolled': false }]"
		:style="{'--down-chevron': 'url(' + downChevron + ')', '--down-chevron-blue': 'url(' + downChevronBlue + ')', '--down-chevron-dark-blue': 'url(' + downChevronDarkBlue + ')'}"
	>
		<select
			v-model="selectedPage"
			@change="handlePageChange"
		>
			<option
				:value="selectedPage"
				selected
			>Jump to section</option>
			<option
				v-for="(page, index) in parsedPages"
				:key="index"
				:value="page.anchor_link ? page.anchor_link.url : 'top'"
				v-html="page.anchor_link ? page.anchor_link.title : 'Untitled'"
			></option>
		</select>
	</div>
</template>

<script>
import downChevron from '../../images/chevron_down_white.svg';
import downChevronBlue from '../../images/chevron_down_blue.svg';
import downChevronDarkBlue from '../../images/chevron_down_dark_blue.svg';

export default {
	name: 'MobilePageSelect',
	props: {
		pages: {},
		parent_anchor: {
			default: 'top',
		},
	},
	data() {
		return {
			selectedPage: 'top',
			isSticky: false,
			isScrolled: false,
			downChevron: downChevron,
			downChevronBlue: downChevronBlue,
			downChevronDarkBlue: downChevronDarkBlue,
		};
	},
	computed: {
		parsedPages() {
			if (this.pages) {
				return JSON.parse(this.pages);
			} else {
				return null;
			}
		},
	},
	methods: {
		navigateToPage() {
			if (this.selectedPage) {
				window.location.href = this.selectedPage;
			}
		},
		handleScroll() {
			this.isScrolled = window.scrollY > 0;
			this.isSticky = window.scrollY > 100;
		},
		handlePageChange() {
			if (this.selectedPage === 'top') {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			} else if (this.selectedPage) {
				window.location.href = this.selectedPage;
			}
		},
	},
	mounted() {
		if (this.parsedPages.length > 0) {
			this.selectedPage = this.parsedPages[0].value;
		}

		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
.mobile-page-select {
	margin-top: 40px;
	display: none;

	@media (max-width: $mobile-xl) {
		display: block;
	}

	select {
		background-color: var(--white);
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border-radius: 0;
		opacity: 1;
		padding: 6px 40px 6px 16px !important;
		height: 48px !important;
		// border: 0 !important;
		outline: none;
		width: 100%;
		grid-column: span 4;
		background-image: var(--down-chevron) !important;
		background-size: 14px 14px !important;
		background-position: calc(100% - 10px) !important;
		background-repeat: no-repeat !important;
		color: var(--black);
		font: normal normal normal 17px/24px var(--primary-font-family);
		border: 1px solid var(--white);
		// border-bottom: 1px solid var(--midnight-black) !important;

		option {
			color: var(--midnight);
			font: normal normal 500 17px/24px var(--primary-font-family);
		}

		&:hover {
			cursor: pointer;
			transition: 0.2s ease all;
		}

		.theme--blue & {
			background-color: var(--cobalt);
			color: var(--white);
		}

		.theme--dark_blue & {
			border: 1px solid transparent;
			background-color: var(--cobalt);
			color: var(--white);
		}

		.theme--white &,
		.theme--none & {
			background-color: transparent;
			border: 1px solid var(--midnight);
			color: var(--midnight);
			background-image: var(--down-chevron-dark-blue) !important;
		}
	}

	&.scrolled {
		position: fixed;
		padding: 20px;
		top: -100px;
		left: 0;
		right: 0;
		z-index: 1000; /* Adjust as needed */
		background: white;
		transition: 0.2s ease all;

		select {
			margin-bottom: 0;
		}
	}

	&.sticky {
		position: relative;
		padding: 20px;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1000; /* Adjust as needed */
		background: white;
		transition: 0.2s ease all;
	}
}
</style>
